import { IonCol, IonLabel, IonRow } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import { IOption } from '../../../../../common/common.types'
import SInput from '../../../../../components/stringInput/StringInput.component'
import {
  setMotorLa,
  setMotorLl,
  setMotorRa,
  setMotorRl,
  setSensoryLa,
  setSensoryLl,
  setSensoryRa,
  setSensoryRl,
  setMotorComments,
  setHeadSensory,
  saveMotorSensory,
} from '../store/motoSensoryAssessment.actions'
import { useDispatch, useSelector } from 'react-redux'
import { getMotorSensoryAssessmentSelector } from '../selectors/motorSensoryAssessment.selector'
import { getDatapointsConfigSelector } from '../../../../configurations/selectors'
import { getNeuroOptionsSelector } from '../../../../options/selectors'
import Validation from '../../../../../components/validation/Validation.component'
import { MotorSensoryAssessmentConstants } from '../store/motoSensoryAssessment.constants'

const MotorSensoryAssessmentContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const motorSensoryAssessment = useSelector(getMotorSensoryAssessmentSelector)
  const { motorComments, motorLa, motorLl, motorRa, motorRl, sensoryLa, sensoryLl, sensoryRa, sensoryRl, headSensory } =
    motorSensoryAssessment

  const neuroOptions = useSelector(getNeuroOptionsSelector)
  const { motorOptions, sensoryOptions } = neuroOptions

  const dataPointsConfig = useSelector(getDatapointsConfigSelector)
  const { DP_MOTOR_PICKLIST, DP_MOTOR_COMMENTS, DP_SENSORY_COMMENTS, DP_SENSORY_PICKLIST } = dataPointsConfig

  const save = () => {
    dispatch(saveMotorSensory())
  }

  const setMotorLAOnChange = (option: IOption) => {
    dispatch(setMotorLa(option))
    save()
  }
  const setMotorRAOnChange = (option: IOption) => {
    dispatch(setMotorRa(option))
    save()
  }
  const setMotorLLOnChange = (option: IOption) => {
    dispatch(setMotorLl(option))
    save()
  }
  const setMotorRLOnChange = (option: IOption) => {
    dispatch(setMotorRl(option))
    save()
  }

  const setSensoryLAOnChange = (option: IOption) => {
    dispatch(setSensoryLa(option))
    save()
  }
  const setSensoryRAOnChange = (option: IOption) => {
    dispatch(setSensoryRa(option))
    save()
  }
  const setSensoryLLOnChange = (option: IOption) => {
    dispatch(setSensoryLl(option))
    save()
  }
  const setSensoryRLOnChange = (option: IOption) => {
    dispatch(setSensoryRl(option))
    save()
  }

  const setMotorCommentsOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setMotorComments(e.detail.value))
    save()
  }

  const setSensoryCommentsOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setHeadSensory(e.detail.value))
    save()
  }

  const motorPicklist: boolean = DP_MOTOR_PICKLIST === 1 ? true : false
  const sensoryPicklistSize: string = motorPicklist ? '6' : '12'

  const sensoryPicklist: boolean = DP_SENSORY_PICKLIST === 1 ? true : false
  const motorPicklistSize: string = sensoryPicklist ? '6' : '12'

  const updatedMotorLa: IOption = { ...motorLa }
  const updatedMotorRa: IOption = { ...motorRa }
  const updatedMotorLl: IOption = { ...motorLl }
  const updatedMotorRl: IOption = { ...motorRl }

  if (motorLa?.name === 'Chemically Paralyzed') {
    updatedMotorLa.name = 'Chem. Paralyzed'
  }

  if (motorRa?.name === 'Chemically Paralyzed') {
    updatedMotorRa.name = 'Chem. Paralyzed'
  }

  if (motorLl?.name === 'Chemically Paralyzed') {
    updatedMotorLl.name = 'Chem. Paralyzed'
  }

  if (motorRl?.name === 'Chemically Paralyzed') {
    updatedMotorRl.name = 'Chem. Paralyzed'
  }
  return (
    <>
      <IonRow className='neuroAccordianRowHeader'>
        {motorPicklist && (
          <IonCol size={motorPicklistSize} className='ion-no-padding neuroAccordianColHeader'>
            <IonLabel>{t('neuro.Motor')}</IonLabel>
          </IonCol>
        )}
        {sensoryPicklist && (
          <IonCol size={sensoryPicklistSize} className='ion-no-padding neuroAccordianColHeader'>
            <IonLabel>{t('neuro.Sensory')}</IonLabel>
          </IonCol>
        )}
      </IonRow>

      <IonRow>
        {motorPicklist && (
          <IonCol className='ion-no-padding picklist' size={motorPicklistSize}>
            <SingleSelect
              dataTestID='MotorLA'
              selectedOption={updatedMotorLa}
              listHeader={t('neuro.MotorLA')}
              label={t('neuro.LA')}
              options={motorOptions}
              action={setMotorLAOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        )}
        {sensoryPicklist && (
          <IonCol className='ion-no-padding picklist' size={sensoryPicklistSize}>
            <SingleSelect
              dataTestID='SensoryLA'
              selectedOption={sensoryLa}
              listHeader={t('neuro.SensoryLA')}
              label={t('neuro.LA')}
              options={sensoryOptions}
              action={setSensoryLAOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        )}
      </IonRow>

      <IonRow>
        {motorPicklist && (
          <IonCol className='ion-no-padding picklist' size={motorPicklistSize}>
            <SingleSelect
              dataTestID='MotorRA'
              selectedOption={updatedMotorRa}
              listHeader={t('neuro.MotorRA')}
              label={t('neuro.RA')}
              options={motorOptions}
              action={setMotorRAOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        )}
        {sensoryPicklist && (
          <IonCol className='ion-no-padding picklist' size={sensoryPicklistSize}>
            <SingleSelect
              dataTestID='SensoryRA'
              selectedOption={sensoryRa}
              listHeader={t('neuro.SensoryRA')}
              label={t('neuro.RA')}
              options={sensoryOptions}
              action={setSensoryRAOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        )}
      </IonRow>

      <IonRow>
        {motorPicklist && (
          <IonCol className='ion-no-padding picklist' size={motorPicklistSize}>
            <SingleSelect
              dataTestID='MotorLL'
              selectedOption={updatedMotorLl}
              listHeader={t('neuro.MotorLL')}
              label={t('neuro.LL')}
              options={motorOptions}
              action={setMotorLLOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        )}

        {sensoryPicklist && (
          <IonCol className='ion-no-padding picklist' size={sensoryPicklistSize}>
            <SingleSelect
              dataTestID='SensoryLL'
              selectedOption={sensoryLl}
              listHeader={t('neuro.SensoryLL')}
              label={t('neuro.LL')}
              options={sensoryOptions}
              action={setSensoryLLOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        )}
      </IonRow>

      <IonRow>
        {motorPicklist && (
          <IonCol className='ion-no-padding picklist' size={motorPicklistSize}>
            <SingleSelect
              dataTestID='MotorRL'
              selectedOption={updatedMotorRl}
              listHeader={t('neuro.MotorRL')}
              label={t('neuro.RL')}
              options={motorOptions}
              action={setMotorRLOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        )}
        {sensoryPicklist && (
          <IonCol className='ion-no-padding picklist' size={sensoryPicklistSize}>
            <SingleSelect
              dataTestID='SensoryRL'
              selectedOption={sensoryRl}
              listHeader={t('neuro.SensoryRL')}
              label={t('neuro.RL')}
              options={sensoryOptions}
              action={setSensoryRLOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        )}
      </IonRow>

      {DP_MOTOR_COMMENTS === 1 && (
        <>
          <IonRow>
            <IonCol className='picklist'>
              <SInput
                label={t('neuro.MotorComments')}
                dataTestID='MotorComments'
                inputValue={motorComments}
                onChangeAction={setMotorCommentsOnChange}
              />
              <Validation id={MotorSensoryAssessmentConstants.SET_MOTORCOMMENTS} />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />
        </>
      )}
      {DP_SENSORY_COMMENTS === 1 && (
        <>
          <IonRow>
            <IonCol className='picklist'>
              <SInput
                label={t('neuro.SensoryComments')}
                dataTestID='SensoryComments'
                inputValue={headSensory}
                onChangeAction={setSensoryCommentsOnChange}
              />
              <Validation id={MotorSensoryAssessmentConstants.SET_HEADSENSORY} />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />
        </>
      )}
    </>
  )
}

export default MotorSensoryAssessmentContent
